module.exports = __webpack_public_path__ + "static/media/Intel.cb14338b.png";